import { useMedia } from "./useMedia";

type PhotoType = EasyTech.Photo | EasyTech.WorkorderPhoto;

interface UsePhotosOptions {
  workorderId: string;
  initialPhotos: PhotoType[];
}

/**
 * Hook pour la gestion des photos dans une workorder
 * @param {UsePhotosOptions} options - Options d'initialisation
 * @param {string} options.workorderId - L'identifiant de la workorder
 * @param {PhotoType[]} options.initialPhotos - Les photos initiales
 * @returns {object} Un objet contenant les photos et les méthodes de gestion
 */
export const usePhotos = ({ workorderId, initialPhotos }: UsePhotosOptions) => {
  const media = useMedia({
    workorderId,
    initialMedia: initialPhotos,
    endpoint: "photos"
  });

  return {
    photos: media.media,
    loadingType: media.loadingType,
    error: media.error,
    loading: media.loading,
    uploadPhoto: media.uploadMedia,
    deletePhoto: media.deleteMedia,
    reloadPhotos: media.reloadMedia,
    setPhotos: media.setMedia,
    getDownloadUrl: media.getDownloadUrl
  };
};